import React, { useEffect } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import {
  selectLang,
  Translate,
} from "../../../../app/store/reducers/main/mainReducer";
import { useSelector } from "react-redux";
import Select from "react-select";
import { Controller, useFormContext } from "react-hook-form";

const customSelectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: "38px",
    borderColor: state.isFocused ? "#86b7fe" : "#dee2e6",
    boxShadow: state.isFocused
      ? "0 0 0 0.25rem rgba(13, 110, 253, 0.25)"
      : "none",
    "&:hover": {
      borderColor: state.isFocused ? "#86b7fe" : "#dee2e6",
    },
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "#0d6efd"
      : state.isFocused
      ? "#e7f1ff"
      : "white",
    color: state.isSelected ? "white" : "#212529",
    "&:active": {
      backgroundColor: "#0d6efd",
    },
  }),
};

const ItemFormAdminProductLabelSection = ({ isEditing }) => {
  const t = Translate;
  const lang = useSelector(selectLang);
  const { control, watch, register, setValue } = useFormContext();

  const productLabelOptions = [
    { value: 3, label: t(lang, "items.label.tobacco") },
    { value: 7, label: t(lang, "items.label.pharma") },
    { value: 11, label: t(lang, "items.label.alcohol") },
    { value: 13, label: t(lang, "items.label.water") },
    { value: 15, label: t(lang, "items.label.beer") },
    { value: 18, label: t(lang, "items.label.appliances") },
    { value: 19, label: t(lang, "items.label.antiseptic") },
  ];

  const isProductLabelEnabled = watch("is_marked");
  const isMedicalCategoryEnabled = watch("is_medical");

  useEffect(() => {
    if (!isProductLabelEnabled) {
      setValue("marking_group_type", null);
      setValue("is_medical", false);
      setValue("is_drug", false);
    }
  }, [isProductLabelEnabled, setValue]);

  useEffect(() => {
    if (!isMedicalCategoryEnabled) {
      setValue("is_drug", false);
    }
  }, [isMedicalCategoryEnabled, setValue]);

  return (
    <Card className="h-100">
      <Card.Header className="border-bottom">
        <Card.Title>
          {t(lang, "items.common.product_label_and_medical")}
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Row className="g-4">
          <Col xs={12}>
            <div className="d-flex align-items-center gap-3">
              <div style={{ minWidth: "220px" }}>
                <Form.Check
                  type="switch"
                  id="product-label-switch"
                  label={t(lang, "items.common.product_label")}
                  {...register("is_marked")}
                />
              </div>
              <div className="flex-grow-1">
                <Controller
                  name="marking_group_type"
                  control={control}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={productLabelOptions}
                      isDisabled={!isProductLabelEnabled}
                      placeholder={t(lang, "items.common.select_category")}
                      isClearable
                      styles={customSelectStyles}
                      noOptionsMessage={() =>
                        t(lang, "items.common.no_options")
                      }
                      value={
                        productLabelOptions.find(
                          (option) => option.value === field.value
                        ) || null
                      }
                      onChange={(option) =>
                        field.onChange(option?.value || null)
                      }
                    />
                  )}
                />
              </div>
            </div>
          </Col>

          <Col xs={12}>
            <div className="d-flex align-items-center gap-3">
              <div style={{ minWidth: "220px" }}>
                <Form.Check
                  type="switch"
                  id="medical-category-switch"
                  label={t(lang, "items.common.medical_category")}
                  disabled={!isProductLabelEnabled}
                  {...register("is_medical")}
                />
              </div>
              <div className="flex-grow-1">
                <Form.Check
                  type="switch"
                  id="medical-medicine-switch"
                  label={t(lang, "items.common.is_medicine")}
                  disabled={!isMedicalCategoryEnabled || !isProductLabelEnabled}
                  {...register("is_drug")}
                />
              </div>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ItemFormAdminProductLabelSection;
